import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { translate } from 'services/i18nService';

import logo from '../../../../../images/logo/logo.png';

import styles from './index.css';


export default class Cam4Logo extends PureComponent {
  static propTypes = { className: PropTypes.string };

  static defaultProps = { className: undefined };

  render() {
    const { className } = this.props;

    return (
      <div className={classNames(styles.logoContainer, className)}>
        <img
          alt={translate('verification.verification.logo.alt')}
          height={30}
          src={logo}
          width={126}
        />
      </div>
    );
  }
}
